// Third-party Integration API — MBO oversight surface (OS-2551) types.
// Hasura returns `bigint` columns (the key PK) as strings to preserve precision, so
// third_party_api_key_id is typed as string and passed back to mutations verbatim.

export enum ApiKeyStatusEnum {
    Active = "active",
    Expired = "expired",
    Revoked = "revoked",
}

export interface IApiAccessKey {
    third_party_api_key_id: string;
    corporate_id: number;
    key_prefix: string;
    label: string | null;
    created_at: string;
    expires_at: string;
    last_used_at: string | null;
    revoked_at: string | null;
}

export interface IApiAccessCorporationConfig {
    corporate_id: number;
    is_enabled: boolean;
}

export interface IApiAccessKeysAggregate {
    aggregate: {
        count: number;
        max: {
            last_used_at: string | null;
        } | null;
    } | null;
}

export interface IApiAccessCorporation {
    corporate_id: number;
    name: string;
    // Object relationship is null when the Corporation has never had a config row (reads as OFF).
    third_party_api_corporate_config: IApiAccessCorporationConfig | null;
    third_party_api_keys_aggregate: IApiAccessKeysAggregate;
}
